import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as capitalProjects from '../../../../capital-projects'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Capital project that was paid for',
    isOptional: false,
    name: 'Capital Project',
    partialId: PartialId.Standard.create('cap_proj'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        capitalProjects.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
